import _classCallCheck from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Param } from "../core/context/Param";
import { ToneAudioNode } from "../core/context/ToneAudioNode";
import { connect } from "../core/context/ToneAudioNode";
import { isAudioParam } from "../core/util/AdvancedTypeCheck";
import { optionsFromArguments } from "../core/util/Defaults";
import { ToneConstantSource } from "./ToneConstantSource";
/**
 * A signal is an audio-rate value. Tone.Signal is a core component of the library.
 * Unlike a number, Signals can be scheduled with sample-level accuracy. Tone.Signal
 * has all of the methods available to native Web Audio
 * [AudioParam](http://webaudio.github.io/web-audio-api/#the-audioparam-interface)
 * as well as additional conveniences. Read more about working with signals
 * [here](https://github.com/Tonejs/Tone.js/wiki/Signals).
 *
 * @example
 * const osc = new Tone.Oscillator().toDestination().start();
 * // a scheduleable signal which can be connected to control an AudioParam or another Signal
 * const signal = new Tone.Signal({
 * 	value: "C4",
 * 	units: "frequency"
 * }).connect(osc.frequency);
 * // the scheduled ramp controls the connected signal
 * signal.rampTo("C2", 4, "+0.5");
 * @category Signal
 */

export var Signal = /*#__PURE__*/function (_ToneAudioNode) {
  _inherits(Signal, _ToneAudioNode);

  var _super = _createSuper(Signal);

  function Signal() {
    var _this;

    _classCallCheck(this, Signal);

    _this = _super.call(this, optionsFromArguments(Signal.getDefaults(), arguments, ["value", "units"]));
    _this.name = "Signal";
    /**
     * Indicates if the value should be overridden on connection.
     */

    _this.override = true;
    var options = optionsFromArguments(Signal.getDefaults(), arguments, ["value", "units"]);
    _this.output = _this._constantSource = new ToneConstantSource({
      context: _this.context,
      convert: options.convert,
      offset: options.value,
      units: options.units,
      minValue: options.minValue,
      maxValue: options.maxValue
    });

    _this._constantSource.start(0);

    _this.input = _this._param = _this._constantSource.offset;
    return _this;
  }

  _createClass(Signal, [{
    key: "connect",
    value: function connect(destination) {
      var outputNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var inputNum = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      // start it only when connected to something
      connectSignal(this, destination, outputNum, inputNum);
      return this;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Signal.prototype), "dispose", this).call(this);

      this._param.dispose();

      this._constantSource.dispose();

      return this;
    } //-------------------------------------
    // ABSTRACT PARAM INTERFACE
    // just a proxy for the ConstantSourceNode's offset AudioParam
    // all docs are generated from AbstractParam.ts
    //-------------------------------------

  }, {
    key: "setValueAtTime",
    value: function setValueAtTime(value, time) {
      this._param.setValueAtTime(value, time);

      return this;
    }
  }, {
    key: "getValueAtTime",
    value: function getValueAtTime(time) {
      return this._param.getValueAtTime(time);
    }
  }, {
    key: "setRampPoint",
    value: function setRampPoint(time) {
      this._param.setRampPoint(time);

      return this;
    }
  }, {
    key: "linearRampToValueAtTime",
    value: function linearRampToValueAtTime(value, time) {
      this._param.linearRampToValueAtTime(value, time);

      return this;
    }
  }, {
    key: "exponentialRampToValueAtTime",
    value: function exponentialRampToValueAtTime(value, time) {
      this._param.exponentialRampToValueAtTime(value, time);

      return this;
    }
  }, {
    key: "exponentialRampTo",
    value: function exponentialRampTo(value, rampTime, startTime) {
      this._param.exponentialRampTo(value, rampTime, startTime);

      return this;
    }
  }, {
    key: "linearRampTo",
    value: function linearRampTo(value, rampTime, startTime) {
      this._param.linearRampTo(value, rampTime, startTime);

      return this;
    }
  }, {
    key: "targetRampTo",
    value: function targetRampTo(value, rampTime, startTime) {
      this._param.targetRampTo(value, rampTime, startTime);

      return this;
    }
  }, {
    key: "exponentialApproachValueAtTime",
    value: function exponentialApproachValueAtTime(value, time, rampTime) {
      this._param.exponentialApproachValueAtTime(value, time, rampTime);

      return this;
    }
  }, {
    key: "setTargetAtTime",
    value: function setTargetAtTime(value, startTime, timeConstant) {
      this._param.setTargetAtTime(value, startTime, timeConstant);

      return this;
    }
  }, {
    key: "setValueCurveAtTime",
    value: function setValueCurveAtTime(values, startTime, duration, scaling) {
      this._param.setValueCurveAtTime(values, startTime, duration, scaling);

      return this;
    }
  }, {
    key: "cancelScheduledValues",
    value: function cancelScheduledValues(time) {
      this._param.cancelScheduledValues(time);

      return this;
    }
  }, {
    key: "cancelAndHoldAtTime",
    value: function cancelAndHoldAtTime(time) {
      this._param.cancelAndHoldAtTime(time);

      return this;
    }
  }, {
    key: "rampTo",
    value: function rampTo(value, rampTime, startTime) {
      this._param.rampTo(value, rampTime, startTime);

      return this;
    }
  }, {
    key: "value",
    get: function get() {
      return this._param.value;
    },
    set: function set(value) {
      this._param.value = value;
    }
  }, {
    key: "convert",
    get: function get() {
      return this._param.convert;
    },
    set: function set(convert) {
      this._param.convert = convert;
    }
  }, {
    key: "units",
    get: function get() {
      return this._param.units;
    }
  }, {
    key: "overridden",
    get: function get() {
      return this._param.overridden;
    },
    set: function set(overridden) {
      this._param.overridden = overridden;
    }
  }, {
    key: "maxValue",
    get: function get() {
      return this._param.maxValue;
    }
  }, {
    key: "minValue",
    get: function get() {
      return this._param.minValue;
    }
    /**
     * See [[Param.apply]].
     */

  }, {
    key: "apply",
    value: function apply(param) {
      this._param.apply(param);

      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(ToneAudioNode.getDefaults(), {
        convert: true,
        units: "number",
        value: 0
      });
    }
  }]);

  return Signal;
}(ToneAudioNode);
/**
 * When connecting from a signal, it's necessary to zero out the node destination
 * node if that node is also a signal. If the destination is not 0, then the values
 * will be summed. This method insures that the output of the destination signal will
 * be the same as the source signal, making the destination signal a pass through node.
 * @param signal The output signal to connect from
 * @param destination the destination to connect to
 * @param outputNum the optional output number
 * @param inputNum the input number
 */

export function connectSignal(signal, destination, outputNum, inputNum) {
  if (destination instanceof Param || isAudioParam(destination) || destination instanceof Signal && destination.override) {
    // cancel changes
    destination.cancelScheduledValues(0); // reset the value

    destination.setValueAtTime(0, 0); // mark the value as overridden

    if (destination instanceof Signal) {
      destination.overridden = true;
    }
  }

  connect(signal, destination, outputNum, inputNum);
}